import { useCallback, useMemo } from 'react';
import { useLanguage } from '../context/LanguageContext';

const useTranslation = (namespaces = ['common']) => {
  const { language, setLanguage, translate, availableLanguages } = useLanguage();

  const namespaceSignature = useMemo(() => {
    if (Array.isArray(namespaces)) {
      return JSON.stringify(namespaces);
    }
    if (typeof namespaces === 'string') {
      return namespaces;
    }
    return '';
  }, [namespaces]);

  const namespaceList = useMemo(() => {
    if (Array.isArray(namespaces) && namespaces.length > 0) {
      return namespaces;
    }
    if (typeof namespaces === 'string' && namespaces) {
      return [namespaces];
    }
    return ['common'];
  }, [namespaceSignature]);

  const t = useCallback(
    (key, fallback) => {
      const result = translate(namespaceList, key);
      if (result === undefined || result === null) {
        return fallback ?? key;
      }
      return result;
    },
    [namespaceList, translate],
  );

  const hasTranslation = useCallback(
    (key) => translate(namespaceList, key) !== undefined,
    [namespaceList, translate],
  );

  return {
    t,
    language,
    setLanguage,
    availableLanguages,
    hasTranslation,
  };
};

export default useTranslation;
